import { getLayoutForPage } from 'utils/pageLayoutUtils'
import { themeMapper } from 'utils/themeUtils'
import { AppContext } from 'contexts/AppContext'
import SiteSEO from './SEO/SiteSEO'
import { ThemeProvider } from 'styled-components'
import { GlobalFont } from 'utils/GlobalFonts'
import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import SiteQuery from './api/queries/SiteQuery.gql'
import LoggedInQuery from './api/queries/LoggedInQuery.gql'
import SimpleErrorPage from './error/SimpleErrorPage'
import { setUser } from 'utils/Analytics'
import theme from 'theme'

const CareGuideCoreApplication = (props) => {
  const {
    Component,
    pageProps: { domain },
    pageProps,
  } = props

  const { loading: siteQueryLoading, error: siteQueryError, data: siteQueryData } = useQuery(
    SiteQuery
  )

  const siteQueryHasUser = !siteQueryData || !!siteQueryData?.viewer?.user
  const { data: loggedInQueryData } = useQuery(LoggedInQuery, {
    ssr: false,
    fetchPolicy: 'network-only',
    skip: siteQueryHasUser,
  })

  const site = siteQueryData?.site
  const loggedInData = loggedInQueryData || siteQueryData
  const viewer = loggedInData?.viewer
  const user = viewer?.user
  const loggedIn = !!user
  const readyToReportUser = loggedIn || loggedInQueryData

  useEffect(() => {
    if (readyToReportUser) {
      setUser(user)
    }
  }, [readyToReportUser, user])

  if (siteQueryError) {
    return <SimpleErrorPage error={siteQueryError} />
  }

  if (siteQueryLoading || !site) {
    return null
  }

  const Layout = getLayoutForPage(Component)
  const palette = site?.palette
  const assets = site?.assets

  const metaDescription = assets?.metaDescription
  const title = assets?.title
  const favicon = assets?.favicon

  const cleanTheme = themeMapper(palette)
  const mergedColors = Object.assign(theme.colors, cleanTheme.colors)
  theme.colors = mergedColors

  const hasUpgradeCta = Component.hasUpgradeCta === true
  const hasFooter = Component.hideFooter !== true

  return (
    <AppContext.Provider value={{ domain, environment: pageProps.environment, site }}>
      <SiteSEO faviconLink={favicon} domain={domain} />
      <ThemeProvider theme={theme}>
        <Layout
          hasFooter={hasFooter}
          hasUpgradeCta={hasUpgradeCta}
          viewer={viewer}
          loggedIn={loggedIn}
        >
          <GlobalFont />
          <Component
            pageProps={pageProps}
            metaDescription={metaDescription}
            title={title}
            loggedIn={loggedIn}
            viewer={viewer}
          />
        </Layout>
      </ThemeProvider>
    </AppContext.Provider>
  )
}

export default CareGuideCoreApplication
